import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

const institutePortalRoles = new Set([
    'institute_admin',
    'principal',
    'instructor',
    'senior_instructor',
    'admin_staff',
    'accountant',
    'hr',
    'receptionist',
    'counselor',
    'operations',
]);

export default function AuthLayout() {
    const { isAuthenticated, user } = useAuthStore();

    // Redirect if already authenticated
    if (isAuthenticated && user) {
        let redirectPath = '/admin';
        if (user.role === 'student') redirectPath = '/student';
        else if (institutePortalRoles.has(user.role)) redirectPath = '/admin/institute-dashboard';
        return <Navigate to={redirectPath} replace />;
    }

    return (
        // clay-auth-shell lets the Clay Studio theme take over the backdrop and
        // turn the sign-in card into the hero clay tile (see clay-theme.css).
        // The shell itself paints nothing: the body's clay canvas shows through,
        // so the sign-in screen sits on the same material as the rest of the app
        // and follows light/dark without a second palette to keep in sync.
        <div className="clay-auth-shell relative min-h-screen px-4 py-6 lg:px-8">
            {/* Accent blooms, tinted from the theme accent rather than fixed teal */}
            <div className="pointer-events-none absolute inset-0 overflow-hidden">
                <div className="absolute -left-16 top-0 h-80 w-80 rounded-full bg-[var(--clay-accent)] opacity-[0.18] blur-3xl" />
                <div className="absolute -right-16 bottom-0 h-96 w-96 rounded-full bg-[var(--clay-accent)] opacity-[0.12] blur-3xl" />
            </div>

            {/* Faint grid, in the ink colour so it survives dark mode */}
            <div
                className="pointer-events-none absolute inset-0 opacity-[0.05]"
                style={{
                    backgroundImage: 'linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)',
                    backgroundSize: '48px 48px',
                    color: 'var(--clay-ink)',
                }}
            />

            <div className="relative mx-auto flex min-h-[calc(100vh-3rem)] w-full max-w-7xl items-center">
                <div className="w-full">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}
